// Bilingual content (Danish + English) for Lotusgruppen
import { SITE } from "@/config/site";

export const translations = {
  da: {
    nav: {
      home: "Forside",
      ydelser: "Ydelser",
      indsatser: "Indsatser og forløb",
      kommuner: "Kommuner og Kriminalforsorgen",
      akut: "Akutte støtteindsatser",
      udsatte: "Udsatte Borgere",
      adhd: "ADHD",
      autisme: "Autisme / ASF",
      kontakt: "Kontakt",
      cta: "Kontakt os",
    },
    common: {
      readMore: "Læs mere",
      seeServices: "Se hvad vi kan",
      partners: "Samarbejdspartnere",
      phone: "Telefon",
      email: "Email",
      backToTop: "Til toppen",
      langLabel: "Sprog",
    },
    hero: {
      eyebrow: "Pædagogisk, socialfaglig og koordinerende støtte",
      title: "Frigørelse af potentiale, omfavnelse af forskelle",
      subtitle: "Socialpædagogiske, koordinerende og beskæftigelsesrettede forløb for borgere med komplekse støttebehov. Lotusgruppen samarbejder med kommuner, Kriminalforsorgen, behandlingssystemet og virksomheder om afklaring, stabilisering, resocialisering og fastholdelse.",
      primary: "Se vores ydelser",
      secondary: "Kontakt os",
    },
    beskaeftigelse: {
      label: "Beskæftigelse",
      title: "Skræddersyet støtte, der skaber varige forandringer",
      cards: [
        {
          title: "Individuelle løsninger",
          text: "Vi tilrettelægger individuelle indsatser, der imødekommer behovene hos den enkelte borger. Forløbene sammensættes i samarbejde med bestiller og kan omfatte socialpædagogisk støtte, koordinering og beskæftigelsesrettede indsatser.",
        },
        {
          title: "Samarbejde med kommuner",
          text: "Kommuner og andre offentlige bestillere kan rekvirere vores indsatser, der understøtter borgere på vejen mod stabilitet, beskæftigelse og trivsel. Målet er meningsfulde og varige forandringer i tæt samarbejde med bestiller.",
        },
        {
          title: "Vores tilgang",
          text: "Vi arbejder helhedsorienteret og kombinerer socialpædagogiske og koordinerende metoder med beskæftigelse. Vores erfarne team arbejder tæt med borgeren for at afdække styrker, mål og støttebehov – og lægge en individuel plan.",
        },
      ],
    },
    homeAkut: {
      label: "Akutte støtteindsatser",
      title: "Hurtig, udgående støtte når situationen er under pres",
      text: "Efter konkret aftale med bestiller iværksætter vi en afgrænset og intensiv støtteindsats med fokus på stabilisering, koordinering og næste skridt – i borgerens eksisterende rammer.",
    },
    homeCards: {
      label: "Vores fokusområder",
      title: "Lotusblomsten som symbol i vores arbejde",
      items: [
        { key: "udsatte", title: "Udsatte Borgere", text: "Lotusblomsten vokser ud af mudder og stiger mod overfladen i skønhed. Sådan kan udsatte borgere overvinde modgang og blomstre med den rette støtte." },
        { key: "adhd", title: "ADHD", text: "Fleksibilitet, tålmodighed og ro. En omhyggelig, individuel tilgang, der møder borgeren med ADHD præcis der, hvor de er." },
        { key: "autisme", title: "Autisme / ASF", text: "Potentiale, forskellighed og accept. Vi støtter personer med ASF i at udfolde deres unikke evner og navigere i hverdagen." },
      ],
    },
    finalCta: {
      title: "Er du interesseret i at høre mere om vores tilbud?",
      subtitle: "Kontakt os i dag for en uforpligtende samtale om, hvordan vi kan støtte dine borgere.",
      button: "Kontakt os",
      signature: "Dennis Stender Kristjansen",
    },
    ydelser: {
      hero: "Socialpædagogiske indsatser og forløb",
      intro: "Lotusgruppen leverer individuelt tilrettelagte indsatser efter konkret kommunal bestilling – organiseret efter, hvad vi konkret kan levere.",
      whatWeOffer: "Fire indsatsområder",
      bestillerNote: "Lotusgruppen kan indgå som ekstern leverandør i individuelt tilrettelagte sociale og beskæftigelsesrettede indsatser efter konkret kommunal bestilling.",
      generalNote: "Det konkrete bevillingsgrundlag fastlægges af bestiller. Lotusgruppen træffer ikke myndighedsafgørelser, men leverer den aftalte indsats, opfølgning og dokumentation.",
      productsTitle: "De fem forløb",
      productsIntro: "Vores forløb inden for løsladelse og resocialisering – klik for at læse mere.",
      categories: [
        {
          key: "boern",
          label: "Børn, unge og familier",
          cta: "Drøft en indsats for børn, unge eller familier",
          area: "boern-unge-familier",
          henv: "konkret-opgave",
          ref: "Barnets lov anvendes som primær lovmæssig reference, hvor det er relevant.",
          items: [
            "Tidligt forebyggende støtte",
            "Fast kontaktperson til barn, ung eller familie",
            "Praktisk-pædagogisk støtte i hjemmet",
            "Familieorienteret støtte og familiebehandling",
            "Støtteperson til forældre under en anbringelse",
            "Støttet eller observeret samvær efter konkret kommunal bestilling",
            "Ungestøtte og overgang til voksenlivet",
          ],
        },
        {
          key: "voksne",
          label: "Voksne og social stabilisering",
          cta: "Drøft en social støtteindsats",
          area: "voksne-social-stabilisering",
          henv: "konkret-opgave",
          items: [
            "Tidsbegrænset individuel støtte",
            "Socialpædagogisk støtte",
            "Hverdagsstruktur",
            "Økonomi, post og myndighedskontakt",
            "Boligstabilitet",
            "Opsøgende støtte og relationsarbejde",
            "Koordinering med behandling og relevante samarbejdspartnere",
            "Fastholdelse af aftaler og fremmøde",
          ],
        },
        {
          key: "beskaeftigelse",
          label: "Beskæftigelse og fastholdelse",
          cta: "Drøft en beskæftigelsesrettet indsats",
          area: "beskaeftigelse-fastholdelse",
          henv: "konkret-opgave",
          ref: "Bestiller kan være kommunen, kommunens beskæftigelsesindsats, en kommunal myndighed eller en anden offentlig bestiller.",
          items: [
            "Afklaring af ressourcer og støttebehov",
            "Virksomhedspraktik og virksomhedskontakt",
            "Mentor- og støttefunktion",
            "Forberedelse til arbejdsplads eller uddannelse",
            "Fremmøde, arbejdsidentitet og gradvis optrapning",
            "Fastholdelse i praktik, uddannelse eller arbejde",
            "Hurtig indsats ved fravær, konflikt eller risiko for frafald",
          ],
        },
        {
          key: "loesladelse",
          label: "Løsladelse og resocialisering",
          cta: "Drøft et resocialiseringsforløb",
          area: "loesladelse-resocialisering",
          henv: "faglig-vurdering",
          isProducts: true,
        },
      ],
    },
    akut: {
      hero: "Akutte støtteindsatser",
      heroLead: "Hurtig, udgående støtte, når en borgers situation eller et eksisterende forløb er under pres.",
      intro: "Lotusgruppen kan efter konkret aftale med bestiller iværksætte en afgrænset og intensiv støtteindsats med fokus på stabilisering, koordinering og næste skridt.",
      boundary: "Indsatsen er ikke et anbringelses- eller botilbud. Lotusgruppen træffer ikke myndighedsafgørelser og overtager ikke myndighedens ansvar.",
      cta: "Drøft behovet for en akut støtteindsats",
      sections: [
        {
          title: "1. Hurtig faglig afklaring",
          text: "Lotusgruppen afklarer sammen med bestiller den aktuelle situation, opgavens formål, tilgængelige ressourcer og det forventede støttebehov.",
        },
        {
          title: "2. Stabilisering",
          text: "Indsatsen kan blandt andet arbejde med:",
          list: ["Struktur og aftaler", "Fremmøde", "Bolig", "Økonomi og post", "Myndighedskontakt", "Konfliktnedtrapning", "Kontakt til relevante aktører"],
        },
        {
          title: "3. Koordinering",
          text: "Lotusgruppen kan inden for den aftalte opgave understøtte kontakten mellem borger, kommune, Kriminalforsorgen, behandlingssystem og øvrige relevante samarbejdspartnere.",
        },
        {
          title: "4. Overgang til næste indsats",
          text: "Den akutte indsats kan efter evaluering:",
          list: ["Afsluttes", "Forlænges efter ny aftale", "Overgå til Lotus Afklaring", "Overgå til Lotus 72", "Overgå til Lotus Stabil 90", "Overgå til Lotus 180", "Overgå til en anden kommunal indsats"],
        },
      ],
    },
    udsatte: {
      hero: "Lotusblomsten i forhold til udsatte borgere",
      intro: "Lotusblomsten har en symbolsk betydning, der er relevant i forhold til udsatte borgere og deres trivsel. Den vokser ud af mudder og mudret vand, men stiger op mod overfladen og åbner sig i skønhed og renhed.",
      lead: "Denne symbolik kan relateres til udsatte borgeres oplevelse af at overvinde udfordringer og modgang. Uanset hvor svær baggrund eller situation kan være, har de potentiale til at trives og blomstre med den rette støtte og de rette muligheder.",
      pointsTitle: "Aspekter af lotusblomstens symbolik",
      points: [
        { h: "Overvindelse af modgang", t: "Som lotusblomsten vokser op gennem mudderet, kan udsatte borgere lære at overvinde udfordringer og finde vejen mod positiv udvikling og trivsel." },
        { h: "Skønhed i mangfoldighed", t: "Lotusblomster kommer i forskellige farver og størrelser. Udsatte borgere har forskellige baggrunde, og det er vigtigt at værdsætte deres unikke styrker og kvaliteter." },
        { h: "Mulighed for transformation", t: "Lotusblomsten åbner sig og udfolder sin skønhed – et billede på den personlige vækst, som udsatte borgere kan opnå gennem støtte, vejledning og muligheder." },
        { h: "Positiv udstråling", t: "Lotusblomsten har en aura af ro og positivitet – en påmindelse om at skabe et støttende og trygt miljø, hvor borgere føler sig værdsatte." },
      ],
      outro: "Brugen af lotusblomsten som symbol hjælper med at fremme en positiv tilgang, der fokuserer på styrker, potentiale og muligheder for udvikling – og minder både borgeren og de professionelle om vedholdenhed, tålmodighed og troen på forandring.",
    },
    adhd: {
      hero: "Lotusblomsten i det pædagogiske arbejde med ADHD",
      intro: "Håndtering af unge udsatte med ADHD kræver en omhyggelig og individuel tilgang. Lotusblomsten kan symbolisere flere værdifulde principper i arbejdet.",
      pointsTitle: "Principper i arbejdet med ADHD",
      points: [
        { h: "Fleksibilitet", t: "Uanset hvor turbulent vandet er omkring lotusblomsten, forbliver den rolig og fleksibel. Vi tilpasser metoder og tilgange efter den enkeltes behov og situation." },
        { h: "Tålmodighed", t: "Lotusblomsten vokser langsomt og gradvist. På samme måde kræver arbejdet med ADHD tålmodighed og vedholdenhed, da udvikling og læring kan tage tid." },
        { h: "Accept og inklusion", t: "Lotusblomsten vokser i mudret vand, men dens værdi påvirkes ikke. Personer med ADHD skal accepteres og inkluderes uanset udfordringer og forskelligheder." },
        { h: "Selvudvikling", t: "Lotusblomsten repræsenterer transformation. Vi fokuserer på personlig vækst og udvikling – både fagligt og personligt." },
        { h: "Ro og balance", t: "Selvom lotusblomsten vokser i urolige farvande, forbliver den rolig på overfladen. Vi skaber et miljø præget af ro og balance, hvor borgeren kan trives på egne præmisser." },
      ],
      outro: "Lotusblomsten som symbol skaber en positiv tilgang med fokus på styrker, potentiale og muligheder trods de udfordringer, borgeren måtte stå overfor – og minder om vigtigheden af vedholdenhed, tålmodighed og troen på, at forandring er mulig.",
    },
    autisme: {
      hero: "Lotusblomsten i forhold til ASF",
      intro: "Autisme, også kendt som autismespektrumsforstyrrelse (ASF), er en kompleks neurobiologisk tilstand, der påvirker adfærd, kommunikation og social interaktion. Lotusblomsten kan tolkes metaforisk og bringe relevante aspekter frem i forståelsen og støtten af personer med ASF.",
      pointsTitle: "Aspekter i arbejdet med ASF",
      points: [
        { h: "Potentiale og vækst", t: "Som lotusblomsten repræsenterer personer med ASF et stort potentiale for vækst. Med den rette støtte og forståelse kan de udfolde deres unikke evner og talenter." },
        { h: "Forskellighed og skønhed", t: "Lotusblomsten er kendt for sin unikke skønhed. Personer med ASF er unikke i tænkning, opfattelse og adfærd – en kilde til værdi og skønhed, der beriger samfundet." },
        { h: "Accept og inklusion", t: "Lotusblomsten vokser i mudder, men blomstrer alligevel. Personer med ASF skal accepteres og inkluderes uden at blive stigmatiseret eller udelukket." },
        { h: "Forvandling og tilpasning", t: "Lotusblomsten åbner og lukker sig dagligt – et billede på tilpasning. Med passende støtte kan personer med ASF lære at navigere i forskellige situationer." },
      ],
      outro: "Metaforen med lotusblomsten inspirerer til en positiv og værdigende tilgang. Det er vigtigt at tilpasse støtte og intervention til den enkeltes specifikke behov og styrker for at fremme trivsel og udvikling.",
    },
    kontakt: {
      hero: "Kontakt os",
      intro: "Vi er her for at hjælpe! Har du spørgsmål, brug for mere information eller ønsker du at samarbejde med os? Du er altid velkommen til at kontakte os.",
      directTitle: "Kontakt os direkte",
      infoTitle: "Kontaktoplysninger",
      company: "Lotusgruppen ApS",
      address: "Peter Sabroes Gade 7, 2th, 2450 København SV",
      hoursLabel: "Telefontider",
      hours: "Mandag – Fredag: 09.00 – 22.00",
      form: {
        name: "Navn",
        email: "Email",
        phone: "Telefon",
        message: "Besked",
        namePh: "Dit navn",
        emailPh: "din@email.dk",
        phonePh: "Dit telefonnummer",
        messagePh: "Skriv din besked her...",
        forloebLabel: "Hvilket forløb drejer henvendelsen sig om?",
        forloebOptions: [
          { value: "usikker", label: "Jeg er ikke sikker endnu" },
          { value: "lotus-afklaring", label: "Lotus Afklaring" },
          { value: "lotus-72", label: "Lotus 72 – løsladelsesberedskab" },
          { value: "lotus-stabil-90", label: "Lotus Stabil 90" },
          { value: "lotus-180", label: "Lotus 180 – fra løsladelse til arbejde" },
          { value: "lotus-fastholdelse", label: "Lotus Fastholdelse" },
          { value: "anden-ydelse", label: "En anden af Lotusgruppens ydelser" },
        ],
        organizationLabel: "Kommune eller organisation (valgfrit)",
        organizationPh: "F.eks. Københavns Kommune",
        sensitiveNote:
          "Undlad at skrive CPR-nummer eller andre følsomme personoplysninger i formularen. Vi tager den konkrete borgersag i en sikker dialog efter den første kontakt.",
        finderMessage: "Jeg har gennemført Lotusgruppens forløbsvælger og ønsker en dialog om {name}.",
        kommuneMessage: "Jeg ønsker en indledende dialog om en mulig opgave eller indsats.",
        henvendelseLabel: "Hvad drejer henvendelsen sig om? (valgfrit)",
        henvendelsePh: "Vælg (valgfrit)",
        henvendelseOptions: [
          { value: "konkret-opgave", label: "Drøftelse af en konkret opgave" },
          { value: "faglig-vurdering", label: "Faglig vurdering af relevant forløb" },
          { value: "samarbejde", label: "Samarbejde med kommune eller Kriminalforsorgen" },
          { value: "virksomhedspraktik", label: "Virksomhedspraktik eller beskæftigelsessamarbejde" },
          { value: "generel-info", label: "Generel information" },
          { value: "andet", label: "Andet" },
        ],
        indsatsomraadeLabel: "Indsatsområde (valgfrit)",
        indsatsomraadePh: "Vælg (valgfrit)",
        indsatsomraadeOptions: [
          { value: "boern-unge-familier", label: "Børn, unge og familier" },
          { value: "voksne-social-stabilisering", label: "Voksne og social stabilisering" },
          { value: "beskaeftigelse-fastholdelse", label: "Beskæftigelse og fastholdelse" },
          { value: "loesladelse-resocialisering", label: "Løsladelse og resocialisering" },
          { value: "andet", label: "Andet eller endnu ikke afklaret" },
        ],
        areaMessage: "Jeg ønsker en indledende dialog om en mulig indsats inden for {area}.",
        send: "Send besked",
        sending: "Sender...",
        success: "Tak for din besked! Vi vender tilbage hurtigst muligt.",
        error: "Noget gik galt. Prøv igen, eller ring til os.",
        required: "Udfyld venligst navn, email og besked.",
      },
    },
    footer: {
      tagline: "Socialpædagogisk, koordinerende og beskæftigelsesrettet støtte til udsatte borgere i Danmark.",
      talk: "Lad os tale sammen",
      nav: "Navigation",
      contact: "Kontakt",
      rights: "Alle rettigheder forbeholdes.",
    },
  },

  en: {
    nav: {
      home: "Home",
      ydelser: "Services",
      indsatser: "Programmes & pathways",
      kommuner: "Municipalities and the Probation Service",
      akut: "Urgent Support Interventions",
      udsatte: "Vulnerable Citizens",
      adhd: "ADHD",
      autisme: "Autism / ASD",
      kontakt: "Contact",
      cta: "Contact us",
    },
    common: {
      readMore: "Read more",
      seeServices: "See what we do",
      partners: "Partners",
      phone: "Phone",
      email: "Email",
      backToTop: "Back to top",
      langLabel: "Language",
    },
    hero: {
      eyebrow: "Pedagogical, social and coordinating support",
      title: "Unlocking potential, embracing differences",
      subtitle: "Social-pedagogical, coordinating and employment-oriented pathways for citizens with complex support needs. Lotusgruppen works with municipalities, the Probation Service, the treatment system and companies on assessment, stabilisation, resocialisation and retention.",
      primary: "See our services",
      secondary: "Contact us",
    },
    beskaeftigelse: {
      label: "Employment",
      title: "Tailored support that creates lasting change",
      cards: [
        { title: "Individual solutions", text: "We design individual interventions that meet the needs of each citizen. Pathways are put together with the commissioner and can include social-pedagogical support, coordination and employment-oriented efforts." },
        { title: "Cooperation with municipalities", text: "Municipalities and other public commissioners can request our interventions, supporting citizens towards stability, employment and wellbeing. The goal is meaningful, lasting change in close cooperation with the commissioner." },
        { title: "Our approach", text: "We work holistically, combining social-pedagogical and coordinating methods with employment. Our experienced team works closely with the citizen to identify strengths, goals and support needs – and to build an individual plan." },
      ],
    },
    homeAkut: {
      label: "Urgent Support Interventions",
      title: "Fast, outreach support when the situation is under pressure",
      text: "By specific agreement with the commissioner, we launch a defined, intensive support intervention focused on stabilisation, coordination and the next step – within the citizen's existing setting.",
    },
    homeCards: {
      label: "Our focus areas",
      title: "The lotus flower as a symbol in our work",
      items: [
        { key: "udsatte", title: "Vulnerable Citizens", text: "The lotus grows out of mud and rises to the surface in beauty. In the same way, vulnerable citizens can overcome adversity and flourish with the right support." },
        { key: "adhd", title: "ADHD", text: "Flexibility, patience and calm. A careful, individual approach that meets the person with ADHD exactly where they are." },
        { key: "autisme", title: "Autism / ASD", text: "Potential, difference and acceptance. We support people with ASD in unfolding their unique abilities and navigating everyday life." },
      ],
    },
    finalCta: {
      title: "Interested in learning more about what we offer?",
      subtitle: "Contact us today for a no-obligation conversation about how we can support your citizens.",
      button: "Contact us",
      signature: "Dennis Stender Kristjansen",
    },
    ydelser: {
      hero: "Social-pedagogical interventions and pathways",
      intro: "Lotusgruppen delivers individually designed interventions on a specific municipal commission – organised around what we can actually deliver.",
      whatWeOffer: "Four areas of intervention",
      bestillerNote: "Lotusgruppen can act as an external provider in individually designed social and employment-oriented interventions on a specific municipal commission.",
      generalNote: "The specific basis for funding is determined by the commissioner. Lotusgruppen does not make authority decisions, but delivers the agreed intervention, follow-up and documentation.",
      productsTitle: "The five pathways",
      productsIntro: "Our pathways within release and resocialisation – click to read more.",
      categories: [
        {
          key: "boern",
          label: "Children, young people and families",
          cta: "Discuss support for children, young people or families",
          area: "boern-unge-familier",
          henv: "konkret-opgave",
          ref: "The Children's Act is used as the primary legal reference where relevant.",
          items: [
            "Early preventive support",
            "Fixed contact person for a child, young person or family",
            "Practical-pedagogical support in the home",
            "Family-oriented support and family treatment",
            "Support person for parents during a placement",
            "Supported or observed contact on a specific municipal commission",
            "Youth support and transition to adult life",
          ],
        },
        {
          key: "voksne",
          label: "Adults and social stabilisation",
          cta: "Discuss a social support effort",
          area: "voksne-social-stabilisering",
          henv: "konkret-opgave",
          items: [
            "Time-limited individual support",
            "Social-pedagogical support",
            "Everyday structure",
            "Finances, mail and authority contact",
            "Housing stability",
            "Outreach support and relationship work",
            "Coordination with treatment and relevant partners",
            "Keeping appointments and attendance",
          ],
        },
        {
          key: "beskaeftigelse",
          label: "Employment and retention",
          cta: "Discuss an employment-oriented effort",
          area: "beskaeftigelse-fastholdelse",
          henv: "konkret-opgave",
          ref: "The commissioner may be the municipality, the municipal employment effort, a municipal authority or another public commissioner.",
          items: [
            "Assessment of resources and support needs",
            "Work placement and company contact",
            "Mentor and support function",
            "Preparation for a workplace or education",
            "Attendance, work identity and gradual step-up",
            "Retention in placement, education or work",
            "Rapid response to absence, conflict or risk of drop-out",
          ],
        },
        {
          key: "loesladelse",
          label: "Release and resocialisation",
          cta: "Discuss a resocialisation pathway",
          area: "loesladelse-resocialisering",
          henv: "faglig-vurdering",
          isProducts: true,
        },
      ],
    },
    akut: {
      hero: "Urgent Support Interventions",
      heroLead: "Fast, outreach support when a citizen's situation or an existing pathway is under pressure.",
      intro: "By specific agreement with the commissioner, Lotusgruppen can launch a defined, intensive support intervention focused on stabilisation, coordination and the next step.",
      boundary: "The intervention is not a placement or residential service. Lotusgruppen does not make authority decisions and does not take over the authority's responsibility.",
      cta: "Discuss the need for an urgent support intervention",
      sections: [
        {
          title: "1. Rapid professional assessment",
          text: "Together with the commissioner, Lotusgruppen clarifies the current situation, the purpose of the task, available resources and the expected support need.",
        },
        {
          title: "2. Stabilisation",
          text: "The intervention may work with, among other things:",
          list: ["Structure and agreements", "Attendance", "Housing", "Finances and mail", "Authority contact", "Conflict de-escalation", "Contact with relevant actors"],
        },
        {
          title: "3. Coordination",
          text: "Within the agreed task, Lotusgruppen can support contact between the citizen, the municipality, the Probation Service, the treatment system and other relevant partners.",
        },
        {
          title: "4. Transition to the next intervention",
          text: "After evaluation, the urgent intervention can:",
          list: ["Be concluded", "Be extended by new agreement", "Transition to Lotus Assessment", "Transition to Lotus 72", "Transition to Lotus Stabil 90", "Transition to Lotus 180", "Transition to another municipal intervention"],
        },
      ],
    },
    udsatte: {
      hero: "The lotus flower and vulnerable citizens",
      intro: "The lotus flower carries a symbolic meaning relevant to vulnerable citizens and their wellbeing. It grows out of mud and murky water, yet rises to the surface and opens in beauty and purity.",
      lead: "This symbolism relates to vulnerable citizens' experience of overcoming challenges and adversity. No matter how difficult their background or situation, they have the potential to thrive and flourish with the right support and opportunities.",
      pointsTitle: "Aspects of the lotus symbolism",
      points: [
        { h: "Overcoming adversity", t: "As the lotus grows up through the mud, vulnerable citizens can learn to overcome challenges and find their way towards positive development and wellbeing." },
        { h: "Beauty in diversity", t: "Lotus flowers come in different colours and sizes. Vulnerable citizens have different backgrounds, and it is important to value their unique strengths and qualities." },
        { h: "Potential for transformation", t: "The lotus opens and unfolds its beauty – an image of the personal growth vulnerable citizens can achieve through support, guidance and opportunity." },
        { h: "Positive presence", t: "The lotus has an aura of calm and positivity – a reminder to create a supportive, safe environment where citizens feel valued." },
      ],
      outro: "Using the lotus as a symbol helps foster a positive approach focused on strengths, potential and opportunities for development – reminding both the citizen and the professionals of perseverance, patience and belief in change.",
    },
    adhd: {
      hero: "The lotus flower in pedagogical work with ADHD",
      intro: "Supporting vulnerable young people with ADHD requires a careful, individual approach. The lotus flower can symbolise several valuable principles in this work.",
      pointsTitle: "Principles in working with ADHD",
      points: [
        { h: "Flexibility", t: "No matter how turbulent the water around the lotus, it remains calm and flexible. We adapt methods and approaches to each person's needs and situation." },
        { h: "Patience", t: "The lotus grows slowly and gradually. Likewise, working with ADHD requires patience and perseverance, as development and learning can take time." },
        { h: "Acceptance and inclusion", t: "The lotus grows in murky water, but its value is unaffected. People with ADHD should be accepted and included regardless of challenges and differences." },
        { h: "Self-development", t: "The lotus represents transformation. We focus on personal growth and development – both professionally and personally." },
        { h: "Calm and balance", t: "Though the lotus grows in restless waters, it stays calm on the surface. We create an environment of calm and balance where the citizen can thrive on their own terms." },
      ],
      outro: "The lotus as a symbol creates a positive approach focused on strengths, potential and opportunities despite challenges – reminding us of the importance of perseverance, patience and belief that change is possible.",
    },
    autisme: {
      hero: "The lotus flower and ASD",
      intro: "Autism, also known as autism spectrum disorder (ASD), is a complex neurobiological condition affecting behaviour, communication and social interaction. The lotus flower can be interpreted metaphorically, bringing forward relevant aspects in understanding and supporting people with ASD.",
      pointsTitle: "Aspects in working with ASD",
      points: [
        { h: "Potential and growth", t: "Like the lotus, people with ASD hold great potential for growth. With the right support and understanding, they can unfold their unique abilities and talents." },
        { h: "Difference and beauty", t: "The lotus is known for its unique beauty. People with ASD are unique in thinking, perception and behaviour – a source of value and beauty that enriches society." },
        { h: "Acceptance and inclusion", t: "The lotus grows in mud yet still blooms. People with ASD should be accepted and included without being stigmatised or excluded." },
        { h: "Transformation and adaptation", t: "The lotus opens and closes daily – an image of adaptation. With appropriate support, people with ASD can learn to navigate different situations." },
      ],
      outro: "The lotus metaphor inspires a positive and dignifying approach. It is important to tailor support and intervention to each person's specific needs and strengths to foster wellbeing and development.",
    },
    kontakt: {
      hero: "Contact us",
      intro: "We are here to help! Do you have questions, need more information or want to collaborate with us? You are always welcome to get in touch.",
      directTitle: "Contact us directly",
      infoTitle: "Contact details",
      company: "Lotusgruppen ApS",
      address: "Peter Sabroes Gade 7, 2th, 2450 Copenhagen SV",
      hoursLabel: "Phone hours",
      hours: "Monday – Friday: 09.00 – 22.00",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Message",
        namePh: "Your name",
        emailPh: "you@email.com",
        phonePh: "Your phone number",
        messagePh: "Write your message here...",
        forloebLabel: "Which pathway is your enquiry about?",
        forloebOptions: [
          { value: "usikker", label: "I'm not sure yet" },
          { value: "lotus-afklaring", label: "Lotus Assessment" },
          { value: "lotus-72", label: "Lotus 72 – release readiness" },
          { value: "lotus-stabil-90", label: "Lotus Stabil 90" },
          { value: "lotus-180", label: "Lotus 180 – from release to work" },
          { value: "lotus-fastholdelse", label: "Lotus Retention" },
          { value: "anden-ydelse", label: "Another of Lotusgruppen's services" },
        ],
        organizationLabel: "Municipality or organisation (optional)",
        organizationPh: "E.g. City of Copenhagen",
        sensitiveNote:
          "Please do not write CPR numbers or other sensitive personal data in the form. We handle the specific citizen case in a secure dialogue after first contact.",
        finderMessage: "I have completed Lotusgruppen's pathway finder and would like a dialogue about {name}.",
        kommuneMessage: "I would like an initial dialogue about a possible task or effort.",
        henvendelseLabel: "What is your enquiry about? (optional)",
        henvendelsePh: "Select (optional)",
        henvendelseOptions: [
          { value: "konkret-opgave", label: "Discussing a specific case" },
          { value: "faglig-vurdering", label: "Professional assessment of a relevant pathway" },
          { value: "samarbejde", label: "Collaboration with a municipality or the Probation Service" },
          { value: "virksomhedspraktik", label: "Work placement or employment collaboration" },
          { value: "generel-info", label: "General information" },
          { value: "andet", label: "Other" },
        ],
        indsatsomraadeLabel: "Area of intervention (optional)",
        indsatsomraadePh: "Select (optional)",
        indsatsomraadeOptions: [
          { value: "boern-unge-familier", label: "Children, young people and families" },
          { value: "voksne-social-stabilisering", label: "Adults and social stabilisation" },
          { value: "beskaeftigelse-fastholdelse", label: "Employment and retention" },
          { value: "loesladelse-resocialisering", label: "Release and resocialisation" },
          { value: "andet", label: "Other or not yet determined" },
        ],
        areaMessage: "I would like an initial dialogue about a possible effort within {area}.",
        send: "Send message",
        sending: "Sending...",
        success: "Thank you for your message! We'll get back to you as soon as possible.",
        error: "Something went wrong. Please try again, or call us.",
        required: "Please fill in name, email and message.",
      },
    },
    footer: {
      tagline: "Social-pedagogical, coordinating and employment-oriented support for vulnerable citizens in Denmark.",
      talk: "Let's talk",
      nav: "Navigation",
      contact: "Contact",
      rights: "All rights reserved.",
    },
  },
};

export const CONTACT = {
  phone: SITE.contact.phone,
  phoneRaw: SITE.contact.phoneRaw,
  email: SITE.contact.email,
};
